export default __webpack_public_path__ + "static/media/ukiyopepe.36304d41.gif";